import { FileEdit, Trash2 } from "lucide-react";
import React from "react";

const QuestionBox = ({ questionText, choices, correctAnswers }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-md p-4">
      <h3 className="text-lg font-semibold mb-2">{questionText}</h3>
      <ul className="mb-2">
        {choices.map((choice, idx) => (
          <li key={idx} className="text-gray-700">{`${idx + 1}. ${choice}`}</li>
        ))}
      </ul>
      <p className="text-sm text-green-600 font-bold">
        Correct Answer: {correctAnswers.join(", ")}
      </p>
      <div className="flex space-x-2 mt-3">
        <button className="text-green-500 hover:text-green-700">
          <FileEdit />
        </button>
        <button className="text-red-500 hover:text-red-700">
          <Trash2 />
        </button>
      </div>
    </div>
  );
};

export default QuestionBox;
